import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portal component
 *
 * Parameter useRootContainer allows third party component PerfectScrollbar to initiate cleanly as child
 *
 * @param children
 * @param useRootContainer
 * @returns {null|*}
 * @constructor
 */
const Portal = ({ children, useRootContainer = false }) => {
  const mount = document.getElementById('portal-root');
  const root = document.getElementById('root');
  const el = document.createElement('div');

  useEffect(() => {
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el, mount]);

  if (el === null) return null;

  return createPortal(children, useRootContainer ? root : el);
};

export { Portal };
